import {useTranslation} from 'react-i18next';
import {TFunction} from 'i18next';
import {cn} from '@chekin/guestapp-ui-kit';
import {FormTypes} from './types';
import {EsimPackage} from '@chekin/core';
import {Checkbox} from '@guestapp/old-ui-kit';
import {Controller, useFormContext} from 'react-hook-form';
import {PackageTag} from './PackageTag';

const getTitle = (t: TFunction) => (esimPackage: EsimPackage) => {
  return `${esimPackage.package_data} ${
    esimPackage.package_voice ? ' / ' + esimPackage.package_voice + t('min') : ''
  } ${esimPackage.package_text ? ' / ' + esimPackage.package_text + t('SMS') : ''} `;
};

type Props = {
  esimPackage: EsimPackage;
  currencySign?: string;
};
export const PackageCheckbox = ({esimPackage, currencySign}: Props) => {
  const {control} = useFormContext<FormTypes>();
  const {t} = useTranslation();

  return (
    <Controller
      name={`${esimPackage.package_id}.checked`}
      control={control}
      render={({field: {onChange, value, ...field}}) => (
        <Checkbox
          className={cn(
            'p-4 rounded-2xl border border-[hsl(var(--border))] [&>:nth-child(2)]:w-full',
            {
              'border-[var(--primary)] bg-[color-mix(in_srgb,var(--primary)_10%,_var(--navigation-background))]':
                value,
              'bg-[var(--navigation-background)]': !value,
            },
          )}
          onChange={() => onChange(!value)}
          value={value}
          label={
            <span className="flex items-center glap-2 text-sm font-semibold justify-between w-full">
              <span className="grow flex items-center gap-2 flex-wrap">
                {getTitle(t)(esimPackage)}
                {esimPackage.package_is_unlimited && (
                  <PackageTag>{t('esim.choose_plan.best_value')}</PackageTag>
                )}
              </span>
              <span className="shrink-0">
                {currencySign}
                {esimPackage.package_price}
              </span>
            </span>
          }
          {...field}
        />
      )}
    />
  );
};
